import React, {Component} from 'react';
import axios from 'axios';
import {FaCreditCard} from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class AdminFinishRechargeCreditComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            isNotification: '',
            textNotification: '',
            credit: 0,
            payment: {},
            vietQr: false
        }
    }

    componentDidMount() {
        this.props.updateUrlRedirect({ url: window.location.href })
        window.scrollTo(0, 0);
        this.getDetailPayment( this.props.paymentId );

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getDetailPayment = (paymentId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/getDetailPayment/' + paymentId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data.payment);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        payment: ref.data.payment,
                        credit: ref.data.credit,
                        loadPage: false,
                        vietQr: ref.data.viet_qr
                    })

                    let item = {
                        credit: ref.data.credit
                    }
                    this.props.updateCredit(item);
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 7999 ) {
                        this.redirect(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu hệ thống thất bại',
                })
            })
    }

    redirect = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.shouldRedirect();
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Hoàn thành yêu cầu nạp tiền"} page={"Yêu cầu nạp tiền"} icon={<FaCreditCard className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody>
                                    {
                                        this.state.error ? (
                                           <Alert color="danger">
                                               { this.state.messageError }
                                           </Alert>
                                        ) : (
                                            <>
                                                {
                                                    this.checkNotification()
                                                }
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="info-company">
                                                            <div className="info-bank">
                                                                <b>Bank Name:</b> { this.state.payment.method_payment } <br />
                                                                <b>Account Name:</b> { this.state.payment.accountName } <br />
                                                                <b>Account Number:</b> { this.state.payment.accountNumber } <br />
                                                            </div>
                                                            <b>Thông tin chi tiết:</b> <br />
                                                            - Loại giao dịch: Chuyển khoản ngân hàng <br />
                                                            - Số dư tài khoản: { this.addCommas(this.state.credit) } ₫ <br />
                                                            - Số tiền nạp: { this.addCommas(this.state.payment.amount) } ₫ <br />
                                                            - Mã giao dịch: { this.state.payment.ma_gd } <br />
                                                            {/*- Hướng dẫn: nạp tiền vào tài khoản <a href="https://support.cloudzone.vn/knowledge-base/huong-dan-nap-tien-vao-tai-khoan-cloudzone-portal/">tại đây</a>. <br />*/}
                                                            - <b className="payin-note">Lưu ý: </b> Quý khách ghi nội dung mã giao dịch khi thực hiện chuyển khoản. Hệ thống sẽ tự động cập nhật số dư tài khoản trong vòng 5 đến 10 phút. Hệ thống cập nhật số dư xong sẽ gửi email thông báo cho quý khách.<br />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 qr-container text-center">
                                                        {
                                                            this.state.vietQr ? (
                                                                <>
                                                                    <h4 className="qr-title">Hoặc quét mã QR bên dưới để tự động
                                                                        điền nội dung chuyển khoản</h4>
                                                                    <div className="qr-img">
                                                                        <img src={ this.state.vietQr } alt="Mã QR" width="350" />
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                </div>

                                            </>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminFinishRecharge' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminFinishRechargeCreditComponent);